import { useState } from 'react';
import { Pagination, Stack, Text } from '@ltvco/refresh-lib/theme';
import { useScreenSize } from '@ltvco/refresh-lib/utils';
import { EntryDetails } from './EntryDetails/EntryDetails';
import { QUESTIONS_PER_PAGE } from './constants';
import { SocialSentiment } from 'api/requests/socialSentiments/interfaces';

interface ListContentProps {
  entries: SocialSentiment[];
  onOpenQADisplayModal: () => void;
  selectedEntry?: SocialSentiment;
  setSelectedEntry: (entry?: SocialSentiment) => void;
}

export const ListContent = ({
  entries,
  onOpenQADisplayModal,
  selectedEntry,
  setSelectedEntry,
}: ListContentProps) => {
  const { isMobile } = useScreenSize();
  const [currentPage, setCurrentPage] = useState(1);
  const entriesList = entries || [];
  const entriesLength = entriesList.length;
  const isEmpty = entriesLength === 0;
  const showList = entriesLength > 0;
  const showPagination = entriesLength > QUESTIONS_PER_PAGE;
  const count = Math.ceil(entriesLength / QUESTIONS_PER_PAGE);
  const paginatedEntries =
    entriesList.slice(
      (currentPage - 1) * QUESTIONS_PER_PAGE,
      currentPage * QUESTIONS_PER_PAGE,
    ) || [];

  const handlePageChange = (e: React.ChangeEvent<unknown>, page: number) => {
    setCurrentPage(page);
  };

  return (
    <>
      {showList && (
        <>
          <Stack spacing={3} mt={2}>
            {paginatedEntries.map((item, index) => (
              <EntryDetails
                key={index}
                item={item}
                onOpenQADisplayModal={onOpenQADisplayModal}
                setSelectedEntry={setSelectedEntry}
              />
            ))}
          </Stack>
          {showPagination && (
            <Stack mt={2}>
              <Pagination
                count={count}
                page={currentPage}
                shape="circular"
                onChange={handlePageChange}
                showFirstButton
                showLastButton
                size={isMobile ? 'small' : 'medium'}
                siblingCount={isMobile ? 0 : 2}
                sx={{
                  '&.MuiPagination-root': {
                    display: 'flex',
                    justifyContent: 'center',
                  },
                }}
              />
            </Stack>
          )}
        </>
      )}
      {isEmpty && (
        <Text variant="h4" color="text.secondary" textAlign="center" my={3}>
          No entries found for this vehicle
        </Text>
      )}
    </>
  );
};
